import ColoradoForm from 'components/ColoradoForm'
import GeorgiaForm from 'components/GeorgiaForm'
import NevadaForm from 'components/NevadaForm'
import NewJerseyForm from 'components/NewJerseyForm'
import { useGetStateFormData } from 'hooks/useGetStateFormData'
import { useStateFormMutation } from 'hooks/useStateFormMutation'
import { Banner } from 'slab'

import { useOnboarding } from '../OnboardingContext'
import { type StepComponentProps } from '../types'

type StateAbbreviation = 'CO' | 'NV' | 'GA' | 'NJ'

export function StateFormPage ({
  navigateToPreviousStep,
  navigateToNextStep,
}: StepComponentProps) {
  const { onboardingData } = useOnboarding()
  const { data: stateFormData, isLoading, error, refetch } = useGetStateFormData()
  const stateFormMutation = useStateFormMutation(!!stateFormData?.state_config?.id)

  const stateConfigRequired = onboardingData?.state_config as StateAbbreviation | undefined

  let body = null
  if (stateConfigRequired === 'CO') {
    body = (
      <ColoradoForm
        navigateToNextStep={navigateToNextStep}
        navigateToPreviousStep={navigateToPreviousStep}
        stateFormMutation={stateFormMutation}
        stateFormData={stateFormData}
        isLoading={isLoading}
        error={error}
        refetch={refetch}
      />
    )
  } else if (stateConfigRequired === 'NV') {
    body = (
      <NevadaForm
        navigateToNextStep={navigateToNextStep}
        navigateToPreviousStep={navigateToPreviousStep}
        stateFormMutation={stateFormMutation}
        stateFormData={stateFormData}
        isLoading={isLoading}
        error={error}
        refetch={refetch}
      />
    )
  } else if (stateConfigRequired === 'GA') {
    body = (
      <GeorgiaForm
        navigateToNextStep={navigateToNextStep}
        navigateToPreviousStep={navigateToPreviousStep}
        stateFormMutation={stateFormMutation}
        stateFormData={stateFormData}
        isLoading={isLoading}
        error={error}
        refetch={refetch}
      />
    )
  } else if (stateConfigRequired === 'NJ') {
    body = (
      <NewJerseyForm
        navigateToNextStep={navigateToNextStep}
        navigateToPreviousStep={navigateToPreviousStep}
        stateFormMutation={stateFormMutation}
        stateFormData={stateFormData}
        isLoading={isLoading}
        error={error}
        refetch={refetch}
      />
    )
  }

  // This should not happen.
  if (!stateConfigRequired) {
    return (
      <div className='mb-6'>
        <Banner
          title='A problem has occurred while processing your request'
          type='critical'
        >
          Something went wrong. Please try again.
        </Banner>
      </div>
    )
  }

  const stateName = {
    CO: 'Colorado',
    NV: 'Nevada',
    GA: 'Georgia',
    NJ: 'New Jersey'
  }[stateConfigRequired]

  return (
    <div data-testid='StateFormPage'>
      <h1 className='heading-lg text-gray-800 mb-3'>
        {stateName} additional questions
      </h1>
      {body}
    </div>
  )
}
